import React from 'react'
import { PrivateRoute, PrivateRouteProps } from '@ppay/client'

import { routes } from '../routes'

export const Private = (props: Omit<PrivateRouteProps, 'unauthorizedPath'>) => (
  <PrivateRoute {...props} unauthorizedPath={routes.auth.login} />
)
